import { call, put, takeEvery } from 'redux-saga/effects';
import i18next from "i18next";
import * as actionTypes from '../../../constants/ActionTypes/AdminPortal/PrinterModels';
import { _CALLGETAPI } from '../../../api/apiHandler'
import { SUCCESS, _ADMINISTRATOR_API_ENDPOINTS } from '../../../constants/AppConstants';

function _FETCHPRINTER_MODELSLIST(countryCode, printerTypeId){
    const endpoint = _ADMINISTRATOR_API_ENDPOINTS.MANAGE_PRINTER_MODELS.BY_COUNTRY;
    
    const payload = {
        params: {
            countryCode: countryCode,
            printerTypeId: printerTypeId
        }
      }
     return _CALLGETAPI(endpoint, payload)
    .then(response => {
        return response;
    })
    .catch((error) => {
        throw error;
    });
}

function* handleInfo(action){
    try {
        const countryCode = action.countryCode;
        const printerTypeId = action.printerTypeId
        if(countryCode && printerTypeId){
            const result = yield call(_FETCHPRINTER_MODELSLIST, countryCode, printerTypeId);
            if(result.actionStatus.toUpperCase() === SUCCESS) {
                yield put({type: actionTypes.MANAGE_PRINTER_MODELS_BY_COUNTRY_SUCCESS, data: result.result});
            } else {
                yield put({
                    type: actionTypes.MANAGE_PRINTER_MODELS_BY_COUNTRY_ERROR, 
                    message: i18next.t('Admintranslation:ADMIN_COMMON_ERRORS.NO_RECORDS_FOUND')
                });
            }
        } else {
            yield put({
                type: actionTypes.MANAGE_PRINTER_MODELS_BY_COUNTRY_ERROR, 
                message: i18next.t('Admintranslation:ADMIN_COMMON_ERRORS.INVALID_INPUT')
            });
        }
    } catch (e) {
         yield put({type: actionTypes.MANAGE_PRINTER_MODELS_BY_COUNTRY_ERROR, message: i18next.t('Admintranslation:ADMIN_COMMON_ERRORS.TECHNICAL_ERROR')});
    }
}

function* PrinterModels_ByCountry(){
    yield takeEvery(actionTypes.MANAGE_PRINTER_MODELS_BY_COUNTRY_INIT, handleInfo);
}

export default PrinterModels_ByCountry;